import { NavLink } from 'react-router-dom'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React from 'react';

export const AppNavbar = (props: { signOutClickHandler: () => void }) => {

  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <>
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1}}>
        <Container maxWidth={false}>
          <Toolbar disableGutters>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ mr: 2, display: { xs: 'none', md: 'flex' } }}
            >
              Grit Software Systems - B2C Automation Suite
            </Typography>
  
            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: 'block', md: 'none' },
                }}
              >
                <MenuItem onClick={handleCloseNavMenu}>
                  <Link  component={NavLink} to="/test-automation">Test Automation</Link>
                </MenuItem>
                <MenuItem onClick={handleCloseNavMenu}>
                  <Typography textAlign="center"><Link  component={NavLink} to="/contact-us">Contact Us</Link></Typography>
                </MenuItem>
                <Divider />
                <MenuItem onClick={handleCloseNavMenu}>
                  <Typography textAlign="center"><NavLink to='https://app.archbee.io/public/wAuMLW_7a_gQJbYZUuZpI' target="_blank">Documentation</NavLink></Typography>
                </MenuItem>
                <MenuItem onClick={handleCloseNavMenu}>
                  <Typography textAlign="center"><NavLink to='https://github.com/Grit-Software-Systems/b2ctestcaserunner' target="_blank"><FontAwesomeIcon icon={faGithub as IconProp} /></NavLink></Typography>
                </MenuItem>
              </Menu>
            </Box>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}
            >
              Grit Software Systems - B2C Automation Suite
            </Typography>
            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, ml: 'auto' }} justifyContent='flex-end'>
              <Link component={NavLink} color="inherit" underline="none" to="/test-automation" sx={{ mx: 2, display: 'block' }}>
                Test Automation
              </Link>
              <Link component={NavLink} color="inherit" underline="hover" to="/contact-us" sx={{ mx: 2, display: 'block' }}>
                Contact Us
              </Link>
              <div className='my-auto'>|</div>
              <Link color="inherit" underline="hover" href='https://app.archbee.io/public/wAuMLW_7a_gQJbYZUuZpI' target="_blank" rel="noreferrer" sx={{ mx: 2, display: 'block' }}>
                Documentation
            </Link>
            <Link color="inherit" underline="hover" href='https://github.com/Grit-Software-Systems/b2ctestcaserunner' target="_blank" rel="noreferrer" sx={{ mx: 2, display: 'block' }}>
              <FontAwesomeIcon icon={faGithub as IconProp} />
          </Link>
        </Box>
  
        <Box sx={{ flexGrow: 0 }}>
          <Button onClick={props.signOutClickHandler} sx={{ my: 2, color: 'white', display: 'block' }}>Logout</Button>
        </Box>
      </Toolbar>
        </Container >
      </AppBar >
      <Toolbar/>
    </>
  )
}